"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var createMuiTheme_1 = __importDefault(require("@material-ui/core/styles/createMuiTheme"));

var buttonTheme = createMuiTheme_1.default({
  overrides: {
    MuiButton: {
      contained: {
        color: "#fff"
      },
      root: {
        "&:active": {
          backgroundColor: "#2a669f",
          borderColor: "#005cbf",
          boxShadow: "none"
        },
        "&:focus": {
          boxShadow: "0 0 0 0.1rem rgba(0,123,255,.5)"
        },
        "&:hover": {
          backgroundColor: "#4583b9"
        },
        borderRadius: "2px",
        fontFamily: "Omnes",
        textTransform: "capitalize"
      },
      text: {
        "&:hover": {
          backgroundColor: "transparent"
        }
      }
    }
  },
  palette: {
    primary: {
      main: "#2e6fae"
    },
    secondary: {
      main: "#ccc"
    }
  },
  typography: {
    useNextVariants: true
  }
});
exports.default = buttonTheme;